import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import ReactGA from "react-ga";
import DeletePopup from "../../components/DeletePopup";
import { IFormControllerProps, IFormControllerActionProps } from "./IFormController";
import { RootState } from "../../rootReducer";
import * as dynamicFormActionCreators from "../DynamicForm/actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import * as myCartActionCreator from "../MyCart/actionCreators";
import * as TransactionActionCreator from "../ThankYou/actionCreators";
import * as adminActionCreator from "../AdminDashboard/actionCreators";
import { DRAFT_WARRANTY_SELECTED } from '../../constants/storageKeys';
import {
    dateTimeFormatter,
    removeWindowBeforeUnload,
    // removeSessionBeforeUnload,
    errorCalculator,
    getOrderedErrors,
    getLastIdSubstring,
    handleEnter,
    imagePathurl,
    setSessionValue,
    getSessionValue,
} from "../../utils/utils";
import "../../../assets/sass/components/formController.scss";
import constantFile from "../../constants/constantFile";
import AdjustCost from "../AdjustCost";
import * as CONFIG from "../../../config.json";
interface IFormControllerStateProps {
    saveClicked: boolean;
    addToCartClicked: boolean;
    deleteWarranty: boolean;
    errorCounts?: number;
    formErrors?: any;
    nextErrorIndex?: number;
    adjustCostPopupVisible?: any;
}
/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
class FormController extends React.Component<
    IFormControllerProps & IFormControllerActionProps,
    IFormControllerStateProps,
    null
> {
    node: any;
    constructor(props) {
        super(props);
        this.state = {
            saveClicked: false,
            addToCartClicked: false,
            deleteWarranty: false,
            errorCounts: 0,
            formErrors: [],
            nextErrorIndex: 1,
            adjustCostPopupVisible: false,
        };
        this.hidePopUp = this.hidePopUp.bind(this);
    }
    isHandleClickCalled = false;
    componentDidMount() {
        this.props.dynamicFormActions.saveDraftFormSuccess({ payload: "" });
    }
    componentWillUnmount(): void {
        this.setState({
            addToCartClicked: false
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const { isBuildingAddressAvailable } = this.props;
        if (isBuildingAddressAvailable) {
            document.removeEventListener("click", this.handleOutsideClick, false);
        } else {
            document.addEventListener("click", this.handleOutsideClick, false);
        }
        if (
            getSessionValue(DRAFT_WARRANTY_SELECTED) ||
            prevProps.errorDetails !== this.props.errorDetails ||
            (prevProps.formData.residentialWarrantyForm &&
                prevProps.formData.residentialWarrantyForm.NavigationMenu !==
                    this.props.formData.residentialWarrantyForm.NavigationMenu)
        ) {
            setSessionValue(DRAFT_WARRANTY_SELECTED, "");
            this.setState({
                errorCounts: this.errorCounter(),
                formErrors: this.orderedErrorOnCurrentScreen(),
            });
        }
    }
    updateDraftFormData = (isSaveBtnClick: boolean, isUpdate: boolean) => {
        const { formData, warrantyId, formId, paymentActions, globalActions } = this.props;
        const { saveDraftForm, updateDraftForm } = this.props.dynamicFormActions;

        const successCallBack = (data) => {
            this.isHandleClickCalled = false;
            window["AppInsightTrace"].trackTrace(`on save form click successCallBack`);
            ReactGA.event({
                category: "Save Form",
                action: `Save Form: ${data.id}`,
                label: `Save Form: ${data.id} : ${dateTimeFormatter(data.saveTime)}`,
            });
            if (!isSaveBtnClick && formData.residentialWarrantyForm.NavigationMenu == "RP") {
                paymentActions.updateInitTransactionCompleted();
                if (data && data.proceedToPayment) {
                    if (this.props.userInfo.isAdmin) {
                        this.setState({ adjustCostPopupVisible: !this.state.adjustCostPopupVisible });
                        document.body.classList.add("hideOverflow");
                        const validationMessage = (data.errors && data.errors.validationMessage) || "";
                        if (validationMessage) {
                            globalActions.showGlobalError({ Message: validationMessage });
                        }
                    } else {
                        this.goToCart({});
                    }
                } else {
                    const validationMessage = (data.errors && data.errors.validationMessage) || "";
                    globalActions.showGlobalError({ Message: validationMessage });
                }
            }
        };

        const failureCallback = (data) => {
            this.isHandleClickCalled = false;
            let commonErrorMsg = "";
            this.props.paymentActions.updateInitTransactionCompleted();
            if (data && data.response && data.response.data && data.response.data.Message) {
                commonErrorMsg = data.response.data.Message;
                window["AppInsightTrace"].trackException(`on save form click Failure: ${commonErrorMsg} `);
            } else {
                const globalErrorMsg = this.props.globalActions.showGlobalError(
                    (data && data.response && data.response.data) || ""
                );
                commonErrorMsg = globalErrorMsg.payload.errorMessage;
                window["AppInsightTrace"].trackException(`on save form click global Failure: ${commonErrorMsg}`);
            }
            ReactGA.event({
                category: "Error",
                action: `Error: ${commonErrorMsg}`,
                label: `Error: ${commonErrorMsg}`,
            });
        };

        const payload = {
            payload: {
                Id: isUpdate ? warrantyId : formId,
                formData: formData,
                successCallBack: successCallBack,
                failureCallback: failureCallback,
            },
        };

        return isUpdate ? updateDraftForm(payload) : saveDraftForm(payload);
    };

    // save form click event
    saveFormClick = () => {
        if (this.isHandleClickCalled) {
            return;
        }
        const { warrantyId, saveDesktopMsg, saveMobileMsg } = this.props;
        const {
            saveDraftFormSuccess,
            updateBillingAddressStatus,
            updateNavigationMenuStatus,
            validateBuildingAddress,
        } = this.props.dynamicFormActions;

        updateNavigationMenuStatus(true);
        window["AppInsightTrace"].trackTrace(`on save form click`);
        const validateBillAddressCallback = (status) => {
            updateBillingAddressStatus({ payload: status });
            if (status) {
                this.isHandleClickCalled = true;
                this.setState({ saveClicked: false }, () => {
                    document.removeEventListener("click", this.handleOutsideClick, false);
                    window["AppInsightTrace"].trackTrace(`on save form click ${status}`);
                    if (warrantyId) {
                        this.updateDraftFormData(true, true);
                    } else {
                        this.updateDraftFormData(true, false);
                    }
                });
            } else {
                this.setState({ saveClicked: true }, () => {
                    document.addEventListener("click", this.handleOutsideClick, false);
                    if (!saveDesktopMsg || !saveMobileMsg) {
                        saveDraftFormSuccess({ payload: "Unable to save" });
                    }
                });
            }
        };
        validateBuildingAddress({ successCallback: validateBillAddressCallback });
    };

    // submit form click event
    submitFormClick = () => {
        if (this.props.isSubmitClicked) {
            return;
        }
        const {
            formData,
            warrantyId,
            waiverReceived,
            dynamicFormActions: { submitWarranty, submitClicked },
        } = this.props;
        submitClicked(true);
        window["AppInsightTrace"].trackTrace(`on submit form click`);
        const handleSubmitError = (data) => {
            const validationMessage = (data.errors && data.errors.validationMessage) || "";
            if (validationMessage) {
                const payload = {
                    errors: data.errors,
                };
                this.props.globalActions.showGlobalError({ Message: validationMessage });
                this.props.dynamicFormActions.fetchFormErrorResponseSuccess(payload);
            }
        };
        const successCallBack = (data) => {
            submitClicked(false);
            window["AppInsightTrace"].trackTrace(`on submit form click successCallBack`);
            ReactGA.event({
                category: "Submit Form",
                action: `Submit Form: ${data.id}`,
                label: `Submit Form: ${data.id} : ${dateTimeFormatter(data.saveTime)}`,
            });
            handleSubmitError(data);
        };
        const failureCallback = (data) => {
            submitClicked(false);
            let commonErrorMsg = "";
            const validationMessage = (data.errors && data.errors.validationMessage) || "";
            if (validationMessage) {
                handleSubmitError(data);
            } else if (data && data.response && data.response.data && data.response.data.Message) {
                commonErrorMsg = data.response.data.Message;
                window["AppInsightTrace"].trackException(`on submit form click Failure: ${commonErrorMsg} `);
            } else {
                const globalErrorMsg = this.props.globalActions.showGlobalError(
                    (data && data.response && data.response.data) || ""
                );
                commonErrorMsg = globalErrorMsg.payload.errorMessage;
                window["AppInsightTrace"].trackException(`on submit form click global Failure: ${commonErrorMsg}`);
            }
            ReactGA.event({
                category: "Error",
                action: `Error: ${commonErrorMsg}`,
                label: `Error: ${commonErrorMsg}`,
            });
        };
        const payload = {
            payload: {
                Id: warrantyId,
                formData: formData,
                WaiverReceived: waiverReceived,
                successCallBack: successCallBack,
                failureCallback: failureCallback,
            },
        };
        !this.props.isApiCallInProcess && submitWarranty(payload);
    };

    handleOutsideClick = (e) => {
        this.setState({ saveClicked: false }, () => {
            const { isBuildingAddressAvailable } = this.props;
            const { updateBillingAddressStatus } = this.props.dynamicFormActions;
            // ignore clicks on the component itself
            if (this.node.contains(e.target)) {
                return;
            }
            if (!isBuildingAddressAvailable) {
                updateBillingAddressStatus({ payload: true });
            } else {
                // this.saveFormClick();
            }
        });
    };

    navigateNext = () => {
        const { formData } = this.props;
        const currentNavMenu =
            this.props.formData.residentialWarrantyForm && this.props.formData.residentialWarrantyForm.NavigationMenu;
        const currentMenu =
            this.props.menuList &&
            this.props.menuList.length > 0 &&
            this.props.menuList.filter((item) => item.menu.value === currentNavMenu);
        if (
            currentMenu &&
            document.getElementById(
                `${currentMenu[currentMenu.length - 1].id.split("-")[0]}-${
                    parseInt(currentMenu[currentMenu.length - 1].id.split("-")[1]) + 1
                }`.toString()
            ) &&
            formData &&
            formData.residentialWarrantyForm &&
            formData.residentialWarrantyForm.NavigationMenu != "RP"
        ) {
            document
                .getElementById(
                    `${currentMenu[currentMenu.length - 1].id.split("-")[0]}-${
                        parseInt(currentMenu[currentMenu.length - 1].id.split("-")[1]) + 1
                    }`.toString()
                )
                .click();
        } else if (
            formData &&
            formData.residentialWarrantyForm &&
            formData.residentialWarrantyForm.NavigationMenu == "RP" &&
            this.props.isSubmittedForm
        ) {
            this.setState({ deleteWarranty: true });
        }
        // const { updateNavigationMenuStatus, getErrorResponseOnNavChange } = this.props.dynamicFormActions;
        window["AppInsightTrace"].trackEvent("On click of form controller next button");
        if (
            formData &&
            formData.residentialWarrantyForm &&
            formData.residentialWarrantyForm.NavigationMenu == "RP" &&
            !this.props.isSubmittedForm
        ) {
            this.addToMyCart();
        }
    };

    navigatePrevious = () => {
        const currentMenu =
            this.props.menuList &&
            this.props.menuList.length > 0 &&
            this.props.menuList.filter(
                (item) => item.menu.value === this.props.formData.residentialWarrantyForm.NavigationMenu
            );
        if (
            currentMenu &&
            document.getElementById(
                `${currentMenu[currentMenu.length - 1].id.split("-")[0]}-${
                    parseInt(currentMenu[currentMenu.length - 1].id.split("-")[1]) - 1
                }`.toString()
            )
        ) {
            document
                .getElementById(
                    `${currentMenu[currentMenu.length - 1].id.split("-")[0]}-${
                        parseInt(currentMenu[currentMenu.length - 1].id.split("-")[1]) - 1
                    }`.toString()
                )
                .click();
                if (sessionStorage.getItem('continueAsAdminForError')) {
                    sessionStorage.removeItem('continueAsAdminForError');
                }  
                // Removing isVarianceRequested entry on navigation
                if (sessionStorage.getItem('isVarianceRequested')) {
                    sessionStorage.removeItem('isVarianceRequested');
                }    
        }
    };

    goToPayment = () => {
        this.props.paymentActions.updateInitTransaction();
        if (this.props.warrantyId) {
            this.updateDraftFormData(false, true);
        } else {
            this.updateDraftFormData(false, false);
        }
    };

    addToMyCart = () => {
        this.props.paymentActions.updateInitTransaction();
        this.updateDraftFormData(false, true);
        if (sessionStorage.getItem('continueAsAdminForError')) {
            sessionStorage.removeItem('continueAsAdminForError');
        }
        // this.goToPayment();
    };

    goToCart = (obj) => {
        const { TotatlWarrantyCost, ActualWarrantyCost, Currency } = obj;
        const { warrantyId, myCartActions, cartId } = this.props;
        const payload = { warrantyId, TotatlWarrantyCost, ActualWarrantyCost, Currency };
        !!cartId ? myCartActions.addCartItem({ cartId, ...payload }) : myCartActions.createShoppingCart(payload);
        this.setState({
            addToCartClicked: true
        });
    };
    //Adjust copy close methods
    hidePopUp = () => {
        this.props.paymentActions.updateInitTransactionCompleted();
        this.setState({
            adjustCostPopupVisible: false,
        });
        document.body.classList.remove("hideOverflow");
    };

    onDeleteConfirm = () => {
        this.props.adminActions.deleteSubmittedWarrantyClick(this.props.warrantyId);
        this.setState({ deleteWarranty: false });
    };

    onDeleteCancel = () => {
        this.setState({ deleteWarranty: false });
    };

    orderedErrorOnCurrentScreen = () => {
        const {
            formData: { residentialWarrantyForm },
            errorDetails,
            menuKeys,
            uiSchema,
        } = this.props;
        const currMenu = (residentialWarrantyForm && residentialWarrantyForm.NavigationMenu) || "BO";
        const currentPage = menuKeys.find((key) => key[currMenu])[currMenu];
        return getOrderedErrors(errorDetails, currentPage, uiSchema);
    };

    focusNextError = () => {
        const { uiSchema } = this.props;
        const { nextErrorIndex, formErrors } = this.state;
        let id = formErrors[nextErrorIndex];

        if (!id) {
            id = formErrors[0];
            this.setState({
                nextErrorIndex: 1,
            });
        } else {
            this.setState((prevState) => {
                return { nextErrorIndex: prevState.nextErrorIndex + 1 };
            });
        }
        const elmnt: any =
            document.getElementById(id) ||
            document.getElementById(id + "-0") ||
            document.getElementById(getLastIdSubstring(id, uiSchema) + "-0");
        if (elmnt && elmnt.offsetTop) {
            window.scroll(0, elmnt.offsetTop || 0);
            elmnt.focus();
            return true;
        } else if (elmnt && elmnt.offsetTop === 0) {
            elmnt.scrollIntoView({ block: "center", inline: "nearest" });
        }
    };

    errorCounter = () => {
        const enumOption = this.props.formData.residentialWarrantyForm.NavigationMenu;
        if (this.props.menuKeys) {
            switch (enumOption) {
                case "BO": {
                    return errorCalculator(this.props.menuKeys, enumOption, this.props.errorDetails)[
                        "buildingAndOwnerInfo"
                    ];
                }
                case "PD": {
                    return errorCalculator(this.props.menuKeys, enumOption, this.props.errorDetails)["projectDetails"];
                }
                case "RP": {
                    return errorCalculator(this.props.menuKeys, enumOption, this.props.errorDetails)["reviewAndPay"];
                }
                default:
                    return 0;
            }
        } else return 0;
    };

    render() {
        const {
            saveDesktopMsg,
            saveMobileMsg,
            isBuildingAddressAvailable,
            redirectUrl,
            warrantyId,
            formData,
            reviewAndPayData,
            transactionData,
            isTransactionInitiating,
            paymentActions,
            isLoading,
            cartId
        } = this.props;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const isErrorOnSaveForm = saveDesktopMsg && !saveDesktopMsg.includes("Last saved");
        // if transaction completed, navigating to transaction completed page
        if (redirectUrl && transactionData.proceedToPayment) {
            let warrantyCost: any;
            if (reviewAndPayData && reviewAndPayData.residentialWarranty) {
                warrantyCost = reviewAndPayData.residentialWarranty.cost
                    ? parseFloat(reviewAndPayData.residentialWarranty.cost)
                    : "0";
            }
            ReactGA.event({
                category: "Go to payment",
                action: `Go to payment: ${warrantyId}`,
                label: `Go to payment: ${warrantyId} : ${warrantyCost}`,
            });
            removeWindowBeforeUnload();
            setTimeout(() => {
                //removeSessionBeforeUnload();
                window.location.href = redirectUrl;
            }, 300);
            return;
        }

        if (transactionData && !transactionData.proceedToPayment && transactionData.warrantyId) {
            this.props.globalActions.clearGlobalError();
            if (this.props.contractorId) {
                paymentActions.addContractorIdFromPersistData({ contractorId: this.props.contractorId });
            }
            return <Redirect to="resubmitpaymentsuccess" />;
        }

        if (this.state.addToCartClicked && !isLoading && !!cartId && this.props.isSuccess) {
            return <Redirect to="/myCart" />;
        }
        const nextBtnLbl =
            formData && formData.residentialWarrantyForm && formData.residentialWarrantyForm.NavigationMenu == "RP"
                ? this.props.isSubmittedForm && this.props.userInfo.isAdmin
                    ? "DELETE WARRANTY"
                    : "ADD TO CART"
                : "NEXT";

        return (
            <React.Fragment>
                <div id="form-controller-container" className="form-controller-container">
                    {this.state.errorCounts ? (
                        <div
                            id="view_next_error"
                            onClick={this.focusNextError}
                            className="view-next-error-mobile d-flex"
                        >
                            <div className="view-next-error">View Next Error</div>
                            <div className="badge-count-errors">
                                <span className="error-count">{this.state.errorCounts}</span>
                            </div>
                        </div>
                    ) : null}
                    <div className="d-flex">
                        <div
                            ref={(node) => {
                                this.node = node;
                            }}
                        >
                            {!this.props.isSubmittedForm && (
                                <div
                                    tabIndex={10005}
                                    className="d-flex"
                                    onClick={this.saveFormClick}
                                    onKeyPress={handleEnter}
                                >
                                    <img className="save-form-img" alt="saveform" src={`${getimagePath}saveform.png`} />
                                    <div
                                        id="save_form"
                                        className={`title-save-form ${
                                            saveDesktopMsg ? "title-save-form-with-msg" : ""
                                        }`}
                                    >
                                        <span>Save Form</span>
                                        <div id="save_msg" className={`last-saved-form-desktop ${
                                            isErrorOnSaveForm ? "saved-form-error" : ""
                                        }`}>
                                            {saveDesktopMsg}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.props.isSubmittedForm && (
                                <div tabIndex={10005} className="d-flex" onClick={this.submitFormClick}>
                                    <img className="save-form-img" alt="saveform" src={`${getimagePath}saveform.png`} />
                                    <div id="submit_form" className="title-save-form">
                                        Submit Form
                                    </div>
                                </div>
                            )}
                            {!isBuildingAddressAvailable && this.state.saveClicked && (
                                <div className="popover-modal">
                                    <div className="popover-text">
                                        Please provide a building address to enable saving.
                                    </div>
                                </div>
                            )}
                        </div>
                        {this.state.errorCounts && (
                            <div
                                id="view_next_error"
                                onClick={this.focusNextError}
                                className="view-next-error-desktop d-flex"
                            >
                                <div className="view-next-error">View Next Error</div>
                                <div className="badge-count-errors">
                                    <span className="error-count">{this.state.errorCounts}</span>
                                </div>
                            </div>
                        )}
                        <div className="form-btns ml-auto d-flex">
                            <button
                                type="button"
                                tabIndex={10006}
                                id="previous_btn"
                                className="previous"
                                onClick={this.navigatePrevious}
                                onKeyPress={handleEnter}
                            >
                                PREVIOUS
                            </button>
                            <button
                                type="button"
                                tabIndex={10007}
                                id="next_btn"
                                className="next"
                                onClick={this.navigateNext}
                                onKeyPress={handleEnter}
                                disabled={isTransactionInitiating}
                            >
                                {nextBtnLbl}
                            </button>
                        </div>
                    </div>
                    <div id="save_msg" className={`last-saved-form-mobile ${
                                            isErrorOnSaveForm ? "saved-form-error" : ""
                                        }`}>
                        {saveMobileMsg}
                    </div>
                </div>
                {this.state.deleteWarranty && (
                    <DeletePopup
                        popupStatus={this.state.deleteWarranty}
                        popupTitle={constantFile.adminDeleteTitlePopup}
                        popupDescription={constantFile.adminDeleteDescriptionPopup}
                        buttonText={constantFile.adminDeleteConfirmButtonPopup}
                        onConfirm={this.onDeleteConfirm}
                        onCancel={() => this.onDeleteCancel()}
                    />
                )}
                {this.state.adjustCostPopupVisible && <AdjustCost goToCart={this.goToCart} hidePopsUp={this.hidePopUp} />}
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state: RootState): IFormControllerProps {
    return {
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formData: state.dynamicFormInfo.warrantyInfo,
        saveMobileMsg: state.dynamicFormInfo.saveMobileMsg,
        saveDesktopMsg: state.dynamicFormInfo.saveDesktopMsg,
        isBuildingAddressAvailable: state.dynamicFormInfo.isBuildingAddressAvailable,
        reviewAndPayData: state.dynamicFormInfo.reviewAndPayData,
        menuList: state.dynamicFormInfo.navMenus,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        uiSchema: state.dynamicFormInfo.layoutResponse.UISchema,
        menuKeys: state.dynamicFormInfo.menuKeys || [],
        redirectUrl: state.payments.redirectUrl,
        isSubmittedForm: state.adminData.isSubmittedForm,
        transactionData: state.payments.transactionData,
        isTransactionInitiating: state.payments.isTransactionInitiating,
        userInfo: state.adminData.userInfo,
        waiverReceived: state.adminData.waiverReceived,
        contractorId: (state.adminData.contractorSelection && state.adminData.contractorSelection.contractorId) || "",
        isApiCallInProcess: state.dynamicFormInfo.isApiCallInProcess,
        isSubmitClicked: state.dynamicFormInfo.isSubmitClicked,
        isLoading: state.myCartInfo.isLoading,
        isSuccess: state.myCartInfo.success,
        cartId: state.myCartInfo.cartId,
    };
}

export function mapDispatchToProps(dispatch: Dispatch): IFormControllerActionProps {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
        myCartActions: bindActionCreators(myCartActionCreator, dispatch),
        paymentActions: bindActionCreators(TransactionActionCreator, dispatch),
        adminActions: bindActionCreators(adminActionCreator, dispatch),
    };
}

export default connect<IFormControllerProps, IFormControllerActionProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(FormController);
